import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import cx from 'classnames'

const Table = ({ heading, options }) => {
  const { text: headingText, size } = heading || {}

  return (
    <div className={cx('sem__table-basic', {})}>
      {headingText && (
        <h2 className={cx('sem__table-heading', `--${size}`)}>{headingText}</h2>
      )}
      {options && (
        <div className="sem__table-options">
          {map(options, (option, index) => (
            <div key={`option-${index}`} className="sem__table-option">
              {!option.link ? (
                <h4 className="sem__table-heading">{option.heading}</h4>
              ) : (
                <a href={option.link} className="sem_table-heading-link">
                  <h4 className="sem__table-heading">{option.heading}</h4>
                </a>
              )}
              {option.table && (
                <div className="sem__table-container">
                  {map(option.table, (table, tableIndex) => (
                    <table key={`table-${tableIndex}`} className="sem__table">
                      <thead>
                        <tr>
                          {map(table.headings, (tableHeading, headingIndex) => (
                            <th
                              key={`heading-${headingIndex}`}
                              className="sem__table-option-heading"
                            >
                              {tableHeading}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {map(table.columns, (column, columnIndex) => (
                            <td
                              key={`column-${columnIndex}`}
                              className="sem__table-option-column"
                            >
                              {column}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

Table.propTypes = {
  heading: PropTypes.shape({
    text: PropTypes.string,
    size: PropTypes.string,
    link: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      link: PropTypes.string,
      table: PropTypes.arrayOf(
        PropTypes.shape({
          headings: PropTypes.arrayOf(PropTypes.string),
          columns: PropTypes.arrayOf(PropTypes.string),
        }),
      ),
    }),
  ),
}

export default Table
